/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssignPrivacyWarningAliases {
  ASSIGN_PRIVACY_WARNING_MODAL = 'assign-privacy-warning-modal',
  FETCH_HPMS_PRIVACY_WARNING = 'fetch-hpms-privacy-warning',
  HPMS_PRIVACY_WARNING_SERVICE = 'hpms-privacy-warning-service',
  PANEL_0 = 'panel-0',
}
export { AssignPrivacyWarningAliases };
